import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/doctorService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchDoctors = createAsyncThunk("doctors/fetchAll", async (params) => {
  const res = await svc.getDoctors(params);
  return res.data;
});

export const createDoctorThunk = createAsyncThunk("doctors/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createDoctor(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create doctor."));
  }
});

export const updateDoctorThunk = createAsyncThunk("doctors/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateDoctor(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update doctor."));
  }
});

export const deleteDoctorThunk = createAsyncThunk("doctors/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteDoctor(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete doctor."));
  }
});

const doctorSlice = createSlice({
  name: "doctors",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctors.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDoctors.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchDoctors.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createDoctorThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateDoctorThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((d) => d.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteDoctorThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((d) => d.id !== action.payload);
      });
  },
});

export default doctorSlice.reducer;
